import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
// const URL = process.env.NODE_ENV === 'production' ? undefined : 'http://localhost:4000';

// export const socket = io("http://localhost:3001/");
// Direct connection (Cloudflare TLS -> EC2:3001). The old API Gateway proxy
// (zfmgk6cmbd) could not upgrade to WebSocket, pinning every client on billed
// long-polling requests — do not route the socket through API Gateway again.
export const socket = io("https://chat.studiosclo.uk/");